<template>
  <div class="column py-2 px-2 no-selection" @click="$emit('click')">
    <div class="row align-center">
      <JobDot :job="job" />

      <div class="ml-2 light-blue--text translucid">
        {{ job.job.name }}
      </div>
      <div v-if="job.job.result" class="ml-2 tournament-badge">
        {{ results(job.job.result) }}
      </div>

      <el-tooltip
        v-if="job.job.lockedAt"
        class="ml-2"
        effect="dark"
        placement="bottom-start"
      >
        <span slot="content">
          {{ job.job.lockedAt | FormatDate("fromNow") }}
        </span>
        <transition name="fade">
          <v-icon
            class="cursor-pointer"
            light
            color="tenda-grey--text"
            style="font-size: 16px"
          >
            lock
          </v-icon>
        </transition>
      </el-tooltip>

      <div class="flex" />

      <transition name="slide-y-reverse-transition" mode="out-in">
        <el-tooltip
          :key="showTimeFromNow"
          effect="dark"
          placement="bottom-start"
          class="cursor-pointer"
        >
          <span slot="content">{{ showTime | FormatDate("longtime") }}</span>
          <small
            :key="showTimeFromNow"
            :class="job.job.nextRunAt ? 'amber--text' : 'grey--text'"
            v-text="showTimeFromNow"
          />
        </el-tooltip>
      </transition>
    </div>
  </div>
</template>

<script>
import JobDot from "@/admin/Scheduler/JobDot";

import _ from "lodash";

export default {
  name: "JobCard",

  components: {
    JobDot,
  },

  props: {
    job: {
      type: Object,
      required: true,
    },
  },

  computed: {
    showTime() {
      return this.job.job.nextRunAt || this.job.job.lastRunAt;
    },

    showTimeFromNow() {
      return this.$options.filters.FormatDate(this.showTime, "fromNow");
    },
    possibleStatuses() {
      return [
        {
          status: "completed",
          color: "tournament-green--text tournament-green-outline",
        },
        {
          status: "failed",
          color: "tournament-red--text tournament-red-outline",
        },
        {
          status: "running",
          color: "tournament-orange--text tournament-orange-outline",
        },
        {
          status: "scheduled",
          color: "tournament-purple--text tournament-purple-outline",
        },
        {
          status: "queued",
          color: "tournament-blue--text tournament-blue-outline",
        },
      ];
    },
  },

  methods: {
    results(result) {
      return _.compact(result).length;
    },
  },
};
</script>

<style scoped>
.tournament-badge {
  background-color: #f56c6c;
  border-radius: 10px;
  color: #fff;
  display: inline-block;
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  padding: 0 6px;
  text-align: center;
  white-space: nowrap;
  border: 1px solid #fff;
}
</style>



// WEBPACK FOOTER //
// src/admin/Scheduler/ExecutionCard.vue